import { createContext, useContext } from "react";

/**
 * Context for denoting if the current item is rendered in the overflow menu
 */
type OverflowItemContextType = {
  /**
   * Whether the current item is rendered inside the overflow menu
   */
  isInOverflowMenu: boolean;
};

/**
 * Context for managing overflow menu state
 */
export const OverflowItemContext = createContext<OverflowItemContextType>({
  isInOverflowMenu: false,
});

/**
 * Hook for accessing overflow menu context
 * @returns OverflowItemContextType - The overflow menu context
 */
export const useOverFlowItemContext = () => useContext(OverflowItemContext);
